import storage from '../../utils/storage'

const STORAGE_KEY = 'admin_settings'
const STORAGE_KEY_MAP = 'admin_settings_map'

const defaultSettings = {
  thresholds: {
    lowMax: 4,
    mediumMax: 10
  },
  labels: {
    low: '低风险',
    medium: '中风险',
    high: '高风险'
  },
  rules: {
    lowDesc: '低风险：0-4分',
    mediumDesc: '中风险：5-10分',
    highDesc: '高风险：≥11分',
    scoringNote: '"是"选项累加对应分值，"否"和"不了解"不计分'
  },
  survey: {
    expireDays: 3,
    baseUrl: 'http://localhost:8080/#/survey/'
  },
  system: {
    name: 'AI骨干人才保留助手',
    version: 'v3.1'
  }
}

export default {
  state: {
    settingsMap: { '1': { ...defaultSettings } },
    settings: { ...defaultSettings },
    defaultSettings: { ...defaultSettings }
  },
  mutations: {
    SET_SETTINGS(state, s) {
      state.settings = s
      storage.set(STORAGE_KEY, s)
    },
    SET_SETTINGS_FOR_TASK(state, { taskId, settings }) {
      const tid = String(taskId || '1')
      state.settingsMap[tid] = settings
      state.settings = settings
      storage.set(STORAGE_KEY_MAP, state.settingsMap)
      storage.set(STORAGE_KEY, settings)
    },
    LOAD_TASK_SETTINGS(state, taskId) {
      const tid = String(taskId || '1')
      const taskSettings = state.settingsMap[tid]
      if (taskSettings) {
        state.settings = taskSettings
      } else {
        const cloned = JSON.parse(JSON.stringify(state.defaultSettings))
        state.settingsMap[tid] = cloned
        state.settings = cloned
        storage.set(STORAGE_KEY_MAP, state.settingsMap)
      }
    },
    UPDATE_THRESHOLD(state, { key, value }) {
      state.settings.thresholds[key] = value
      storage.set(STORAGE_KEY, state.settings)
    }
  },
  getters: {
    settings: state => state.settings,
    settingsMap: state => state.settingsMap,
    riskThresholds: state => state.settings.thresholds,
    riskLabel: state => level => {
      const t = state.settings.thresholds
      if (level >= 3 || (t && t.mediumMax !== undefined && level > t.mediumMax)) return state.settings.labels.high
      if (level === 2 || (t && t.lowMax !== undefined && level > t.lowMax)) return state.settings.labels.medium
      return state.settings.labels.low
    }
  }
}
